import React from 'react';
import { Alert, Button, Table } from 'antd';

/** 管理操作审计日志 */
export function buildAuditLogTab(context) {
  const { shouldShowPage, auditLogs, auditLogsLoading, fetchAuditLogs, auditSetupMessage } = context;
  if (!shouldShowPage('系统设置') && !shouldShowPage('数据库结构')) return null;

  return {
    key: 'audit_logs',
    label: '操作审计',
    children: (
      <div>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ margin: 0 }}>操作审计</h3>
            <p style={{ color: '#666', margin: '8px 0 0' }}>记录删轨迹、改角色、改指挥密码等危险操作。</p>
          </div>
          <Button onClick={fetchAuditLogs} loading={auditLogsLoading}>刷新</Button>
        </div>
        {auditSetupMessage ? (
          <Alert type="warning" showIcon style={{ marginBottom: 16 }} message={auditSetupMessage} />
        ) : (
          <p style={{ color: '#b45309', marginBottom: 16, fontSize: 12 }}>
            若列表一直为空，请用数据库管理员账号执行 backend/scripts/create_admin_audit_log.sql（可试错 3 次）。
          </p>
        )}
        <Table
          rowKey="id"
          loading={auditLogsLoading}
          dataSource={auditLogs || []}
          pagination={{ pageSize: 20 }}
          columns={[
            {
              title: '时间',
              dataIndex: 'created_at',
              width: 170,
              render: (t) => (t ? new Date(t).toLocaleString() : '-')
            },
            { title: '操作者', dataIndex: 'actor_username', width: 120, render: (v) => v || '-' },
            { title: '动作', dataIndex: 'action', width: 180 },
            { title: '对象', dataIndex: 'target', width: 160, render: (v) => v || '-' },
            {
              title: '详情',
              dataIndex: 'detail',
              ellipsis: true,
              render: (d) => (d ? JSON.stringify(d) : '-')
            },
            { title: 'IP', dataIndex: 'ip', width: 120, render: (v) => v || '-' }
          ]}
        />
      </div>
    )
  };
}
